import { TextBox, Input } from "../../../components/textfield";
import MainButton from "../../../components/button/mainButton";
import SelectField from "../../../components/select/selectField";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiPlusCircle, mdiCloseCircle } from "@mdi/js";
import EmptyModel from "../../../components/modal/emptyModal";

interface ParamsType {
  id: string;
}
const data = [
  {
    id: "1",
    name: "Doctor(DF%)",
    storename: [],
  },
  {
    id: "2",
    name: "Nurse",
    storename: [],
  },
  {
    id: "3",
    name: "Therapist",
    storename: [],
  },
  {
    id: "4",
    name: "Therapist2",
    storename: [],
  },
  {
    id: "5",
    name: "คลีนหน้า/Clean",
    storename: [],
  },
  {
    id: "6",
    name: "แปะยาชา",
    storename: [],
  },
  {
    id: "7",
    name: "ล้างแผล/Dressing",
    storename: [],
  },
  {
    id: "8",
    name: "Anesthiologist(1=4800,15ml)...",
    storename: [],
  },
  {
    id: "9",
    name: "Assistant Anesth",
    storename: [],
  },
];
const EditDoctor = () => {
  const { id } = useParams<ParamsType>();
  const [courseCardID, setCourseCardID] = useState<string>("");
  const [refNo, setRefNo] = useState<string>("");
  const [countNumber, setCountNumber] = useState<string>("");
  const [dateUsed, setDateUsed] = useState<string>("");
  const [cusTomer, setCusTomer] = useState<string>("");
  const [careTaker, setCareTaker] = useState<string>("");
  const [branch, setBranch] = useState<string>("");
  const [state, setState] = useState<any>(data);
  const [selectNum, setSelectNum] = useState<number>(0);
  const [Selected, setSelected] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);

  const option = [
    { value: "1", name: "1" },
    { value: "2", name: "2" },
    { value: "3", name: "3" },
    { value: "4", name: "4" },
  ];
  const header = [{ title: "ตำแหน่ง" }, { title: "ชื่อผู้ดำเนินการ/Operator" }];
  const nurse = [
    { value: "นิมล วาสุทา1", name: "นิมล วาสุทา1" },
    { value: "นิมล วาสุทา2", name: "นิมล วาสุทา2" },
    { value: "นิมล วาสุทา3", name: "นิมล วาสุทา3" },
  ];

  const getAPIs = () => {
    setCourseCardID("R9-CNT61080007");
    setRefNo("xxxxxx");
    setCountNumber("1");
    setDateUsed("2564-12-15");
    setCusTomer("R9-CNT61080007");
  };

  const Update = () => {
    console.log("UPDATE SUCCESS => ", id);
  };

  const handleChange = (e: any) => {
    console.log("e", e);
    setSelected(e);
  };

  function addOperator() {
    // const xOperator = state.OperatorTable;
    // console.log("X", xOperator);

    state[selectNum].storename.push(Selected);
    setState([...state]);
    console.log("state ", state);
    setIsOpen(false);

    // setState({ ...state, state });
  }

  const removename = (index1: any, index2: any) => {
    console.log("index", index1, index2);

    state[index1].storename.splice(index2, 1);
    setState([...state]);
    console.log("remove", state);
  };

  function onClose() {
    setIsOpen(false);
  }

  useEffect(() => {
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar
        btnBack={true}
        title="บันทึกการใช้ / น.ส.รังสิมา แซ่หว่าง (EK-CNT60100015)"
      />
      <div style={{ padding: "0px 40px", margin: "0px 40px" }}>
        <EmptyModel show={isOpen} onClose={onClose} width="20%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 20px",
              fontSize: "14px",
            }}
          >
            <h4>Choose</h4>
            <div className="row justify-center mt-40">
              <SelectField
                className="col-8"
                option={nurse}
                title="พยาบาล"
                onChange={(e) => {
                  handleChange(e.target.value);
                }}
              />
            </div>
            <div className="justify-center mt-40">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                width="120px"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
              <MainButton
                className="mg-10"
                title="ยืนยัน"
                background="#4D7E7F"
                width="120px"
                onClick={() => {
                  //console.log("");
                  addOperator();
                }}
              />
            </div>
          </div>
        </EmptyModel>
        <div className="justify-center">
          <div
            className="col-6 card-view mg-10"
            style={{ padding: "20px 40px", flexDirection: "column" }}
          >
            <div className="row">
              <TextBox
                className="col-6"
                title="Course Card ID"
                value={courseCardID}
              />
              <TextBox className="col-6" title="เลขที่ใบยา/Ref" value={refNo} />
            </div>
            <div className="row mt-20">
              <TextBox
                className="col-6"
                title="จำนวน/Number"
                value={countNumber}
              />
              <Input
                className="col-6"
                type="date"
                title="Date Used"
                value={dateUsed}
                onChange={(e) => {
                  setDateUsed(e.target.value);
                }}
              />
            </div>
          </div>
          <div
            className="col-6 card-view mg-10"
            style={{ padding: "20px 40px", flexDirection: "column" }}
          >
            <div className="row">
              <TextBox
                className="col-6"
                title="ผู้ใช้/Customer"
                value={cusTomer}
              />
              <SelectField
                className="col-6"
                option={option}
                placeholder="น.ส ธันยรัศมิ์ จิระรุ่งโรจน์"
              />
            </div>
            <div className="row mt-20">
              <SelectField
                className="col-6"
                title="ผู้ดูแล"
                option={option}
                placeholder="กษิรา สายพรชัย(หมอเบล)"
                onChange={(e) => {
                  setCareTaker(e.target.value);
                }}
              />
              <SelectField
                className="col-6"
                title="สาขา"
                option={option}
                placeholder="สาทร"
                onChange={(e) => {
                  setBranch(e.target.value);
                }}
              />
            </div>
          </div>
        </div>

        <div className="mt-40">
          <Table header={header}>
            {state.map((item: any, index: any) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="50%">{item.name}</TableColumn>
                <TableColumn width="50%">
                  <div
                    className="font-text-value"
                    style={{
                      display: "flex",
                      justifyContent: "left",
                    }}
                  ></div>

                  <div className="d-flex justify-content-between ">
                    <div>
                      {item.storename.map((name: any, in2: number) => (
                        <span onClick={() => removename(index, in2)}>
                          {name}
                          <Icon
                            path={mdiCloseCircle}
                            size="20"
                            color="#E76464"
                          />
                        </span>
                      ))}
                    </div>
                    <div
                      className="font-text-value"
                      style={{
                        display: "flex",
                        justifyContent: "right",
                      }}
                    >
                      {item.storename.length < 2 && (
                        <div
                          onClick={() => {
                            setSelectNum(index);
                            //addOperator(index);
                            setIsOpen(true);
                          }}
                        >
                          <Icon
                            path={mdiPlusCircle}
                            size="20"
                            color="#4D7E7F"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
        <div className="justify-center mt-20">
          <MainButton title="ยกเลิก" to="#" background="#E76464" />
          <div style={{ width: "20px" }}></div>

          <MainButton title="บันทึก" onClick={Update} />
        </div>
      </div>
    </div>
  );
};
export default EditDoctor;
